import PropTypes from "prop-types";

export default function RecommendationText({ recommendedSizes }) {
  const [firstSize, secondSize] = recommendedSizes;

  return (
    <p className="text-sm italic text-darkGray">
      {`We recommend renting a Size ${firstSize}${secondSize ? ` or ${secondSize}` : ""}`}.
    </p>
  );
}

RecommendationText.propTypes = {
  recommendedSizes: PropTypes.arrayOf(PropTypes.string),
};
